import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import CategoryImageOne from "../../../src/assets/images/7298bc6498bac824964953a026c2cfed8dd0b208.png";
import CategoryTwo from "../../../src/assets/images/7318dcb1c2df37dec0b85913f0d056d2cc6bc5a5.png"
import CategoryThree from "../../../src/assets/images/IMG_8906.jpeg"


const Categories = [
  {
    id: 1,
    image: CategoryImageOne,
    heading: "Tech Stack",
    description: "Master essential programming languages, frameworks, and tools used in real-world software development.",
  },
  {
    id: 2,
    image: CategoryTwo,
    heading: "Academic Excellence",
    description: "Gain mastery in study strategies, critical thinking, and structured learning techniques to excel in your academic pursuits.",
  },
  {
    id: 3,
    image: CategoryThree,
    heading: " Language Mastery",
    description: "Learn new languages, improve your communication skills, and gain fluency through structured lessons and interactive practice.",
  },
];

function LearningPlatform() {
  const navigate = useNavigate();

  // Animation Variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  const staggerContainer = {
    visible: { transition: { staggerChildren: 0.1 } }
  };

  return (
    <div className="bg-white font-sans text-gray-800">
      
      {/* Categories Section */}
      <motion.section 
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={staggerContainer}
        className="max-w-7xl mx-auto py-24 px-6"
      >
        <motion.h1 
          variants={fadeInUp}
          className="text-4xl md:text-5xl font-black text-center mb-16 tracking-tight"
        >
          Categories
        </motion.h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {Categories.map((category) => (
            <motion.div
              key={category.id}
              variants={fadeInUp}
              whileHover={{ y: -10 }}
              whileTap={{ scale: 0.95, transition: { type: "spring", stiffness: 400, damping: 10 } }}
              onClick={() => navigate('/enroll')} // Redirecting to Register
              className="group cursor-pointer rounded-[40px] border-2 border-gray-100 bg-white p-8 
                         shadow-sm hover:shadow-2xl hover:border-[#2b78c5]/20 transition-all duration-500"
            >
              {/* Image Container - Removed Green, used light Gray-50 */}
              <div className="flex justify-center bg-gray-50 rounded-[30px] p-10 mb-8 group-hover:bg-blue-50 transition-colors duration-500">
                <img
                  src={category.image}
                  alt={category.heading}
                  className="w-44 object-contain group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              <h2 className="font-bold text-2xl text-center mb-4 group-hover:text-[#2b78c5] transition-colors">
                {category.heading}
              </h2>

              <p className="text-gray-500 text-center leading-relaxed font-medium">
                {category.description}
              </p>

              {/* Animated CTA */}
              <div className="mt-8 flex justify-center">
                <p className="text-[#2b78c5] font-black text-lg flex items-center gap-2 group-hover:gap-4 transition-all">
                  Tap to enroll 
                  <span className="inline-block animate-bounce">→</span>
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Tutor-Led Learning Section */}
      <motion.section 
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
        className="border-t border-gray-100"
      >
        <div className="max-w-7xl mx-auto px-6 py-20 flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          <div className="max-w-xl">
            <h2 className="text-4xl font-black text-[#2b78c5] mb-4 tracking-tighter">
Tutor-Led Learning
            </h2>
            <p className="text-gray-400 font-bold text-sm uppercase tracking-widest leading-relaxed">
              Learn With Experienced Online Tutors Who Guide And Support You Every Step Of The Way.
            </p>
          </div>
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate('/register')}
            className="bg-[#2b78c5] hover:bg-[#1e5a96] text-white font-black py-5 px-10 rounded-2xl shadow-lg shadow-blue-200 transition-all text-lg"
          >
            Find A Tutor
          </motion.button>
        </div>

        {/* Video Content Section */}
        <div className="max-w-7xl mx-auto pb-24 px-6 text-center">
          <motion.div variants={fadeInUp} className="mb-16">
            <h2 className="text-3xl font-black text-gray-800 mb-2">What you need to know</h2>
            <p className="text-gray-400 text-xl">Everything you need to learn effectively</p>
          </motion.div>

          <motion.div 
            variants={fadeInUp}
            whileHover={{ scale: 1.01 }}
            className="relative max-w-5xl mx-auto aspect-video rounded-[32px] overflow-hidden shadow-2xl border-8 border-white group"
          >
            {/* Soft Glow behind video */}
            <div className="absolute inset-0 bg-[#2b78c5]/5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
            
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/ZGV-jv8JECI"
              title="Peer2Learn Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </motion.div>
        </div>
      </motion.section>
    </div>
  );
}

export default LearningPlatform;